import { ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar";
import { Grid } from "../core/components/grid";
import { Config } from "../core/config/config";
import { Helper } from "../core/util/helper";
import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import React from "react";

interface WarehousesProps {
    entity: {
        Warehouses: { Designation: string, Id: number, Number: string; Type: string; }[]
    };
    onChange: (field, value) => void;
}
export default class Warehouses extends React.Component<WarehousesProps, any> {
    private gridOptions: kendo.ui.GridOptions;
    private standardButtons: Array<ToolBarStandardButton> = [
        { type: ToolBarStandardButtonType.NEW, caption: Helper.getTranslation("WebSMS.Reminder.Add"), enabled: true },
        { type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: true }
    ];
    constructor(props) {
        super(props)
        this.initApp();
    }

    private initApp = () => {
        this.gridOptions = {
            sortable: true,
            pageable: false,
            groupable: false,
            filterable: false,
            selectable: "multiple, row",
            resizable: true,
            scrollable: true,
            editable: false,
            columns: [
                {
                    field: "Designation",
                    title: Helper.getTranslation("Field.BelegMaterial.bezeichnung"),
                },
                {
                    field: "Number",
                    title: Helper.getTranslation("Standard.Number"),
                },
                {
                    field: "Type",
                    title: Helper.getTranslation("Field.Vorgang.typ"),
                }
            ]
        };
    }

    private onChange = (data) => {
        this.props.onChange({ model: "entity.Warehouses" }, data)
    }

    private onStandardClick = async (type: ToolBarStandardButtonType, dataItem) => {
        let data = this.props.entity.Warehouses
        switch (type) {
            case ToolBarStandardButtonType.NEW:
                const tmp = await this.addWarehouses();
                data = data
                    .concat(tmp)
                    .filter((value, index, array) => {
                        return array.findIndex(f => f.Id == value.Id) === index;
                    })
                break;
            case ToolBarStandardButtonType.DELETE:
                const items = Array.isArray(dataItem) ? dataItem : [dataItem]
                data = data.filter(f1 => items.findIndex(f2 => f1.Id == f2.Id) == -1)
                break;
        }
        this.onChange(data);
    }

    private addWarehouses = () => {
        return new Promise<[]>((resolve) => {
            const url = "DynamicSearch/Window/Warehouse?multi=true&openActionDisabled=true&displayPattern=[[designation]]"
            const sheet = General.Sheet.Manager.createSheetWithUrl(url, null, { disableTabTitle: true });
            sheet.bind(SheetEventType.ItemsSelected, (data) => {
                const result = data.data.map((item) => {
                    return {
                        Designation: item.designation,
                        Id: item.id,
                        Number: item.number,
                        Type: item.type
                    }
                });
                resolve(result)
            });
        })
    }

    render() {
        const data = this.props.entity.Warehouses.sort((a, b) => {
            if (a.Designation < b.Designation) {
                return -1;
            } else if (a.Designation > b.Designation) {
                return 1;
            }
            return 0;
        })


        return (
            <div className="flex-container">
                <Grid
                    data={data}
                    options={this.gridOptions}
                    id={"address_warehouse"}
                    standardButtons={this.standardButtons}
                    onClickStandardButton={this.onStandardClick}
                />
            </div>
        );
    }
}